import { AssetGroup, AssetsLiabilities, FinancialAccount } from "@/types/types";

export function isFinancialAccount(
  account: FinancialAccount | AssetsLiabilities
): account is FinancialAccount {
  return "totalBalance" in account;
}

export function isAssetGroupIndividualOrJoint(type: AssetGroup["type"]) {
  return type === "Individual" || type === "Joint";
}
